import type { Api, Log } from '@cruz-com/lookup'
import { baseURL, formatFetchError, getHeader } from '../util'

export async function carsforsaleImportLogs(params: object): Promise<Api.Result<Log.CarsforsaleImport[]>> {
  try {
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/log/carsforsale-import?${new URLSearchParams(params as Record<string, string>)}`, {
      method: 'GET',
      headers,
      next: { revalidate: 5 },
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}
